import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/**
 * @param {{ params?: object, query?: { name?: string, isActive?: boolean, groupType?: 'All' | 'Customer' | 'Product' | 'CrmCustomer', workspaceId?: string, page?: number, limit?: number } }} [option]
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.TagGroup.GetAll(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ name: string, description?: string, color?: string, groupType: 'All' | 'Customer' | 'Product' | 'CrmCustomer' }} form
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.TagGroup.Create(), form);
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.TagGroup.GetById(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ id: string, name: string, description?: string, color?: string, isActive?: boolean, groupType?: 'All' | 'Customer' | 'Product' | 'CrmCustomer' }} form
 */
export const Update = async (form) => {
  const response = await $api.put(Endpoints.TagGroup.Update(), form);
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.TagGroup.Delete(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { tagGroupId: string }, body: Record<string, number> }} option
 *   body: tagId → 0-based order dictionary
 */
export const UpdateTagOrders = async (option) => {
  const response = await $api.put(
    Endpoints.TagGroup.UpdateTagOrders({
      params: option.params,
    }),
    option.body
  );
  return ResponseChecker(defaultMessages, response);
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  UpdateTagOrders,
};
